import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Tab, Tabs, Container, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import LoadingScreen from "src/components/loading-screen/LoadingScreen";
import FooterLogin from "src/layouts/compact/FooterLogin";
import { openVenueFarAwayModal, openVenueLocationModal } from 'src/redux/slices/VenueLocationModalSlice';
import api from "src/utils/axios";
import { fetchImage } from "src/utils/fetchImage";
import useGeolocation from "src/utils/geolocation";
import { useSnackbar } from "../../../components/snackbar";
import CarInformationModal from "../CarInformation/CarInformationModal";
import CartItemModal from "../cartModal/CartItemModal";
import VenueHeader from "../VenueHeader";
import VenueCover from "./VenueCover";
import VenueProfileMenu from "./VenueProfileMenu";
import { getVenueListWithLocationAndType } from "src/redux/slices/venueSlice";
import { useUserLocationEnabled } from "src/components/settings/UserLocationEnabled";
import SelectReservationTime from "src/pages/Venue/reservation/SelectReservationTime";
import ReservationCheckoutSummary from "../Checkout/ReservationCheckoutSummary";
import { format, getDay, parse, isBefore, parseISO, isToday, set } from "date-fns";
import axios from "axios";
const getToken = localStorage.getItem("access_token");

const VenueProfiles = () => {
  const location = useLocation();
  const { selectedTableSize, selectedDate, selectedTime, selectedSlot, confirmationPage, detail, logginView } = (location.state && location.state.isReservation) || {};

  const [activeSection, setActiveSection] = useState({
    calenderDining: true,
    selectReservationTime: false,
  });
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector((state) => state.login);
  const { venues } = useSelector((state) => state.venues);
  const { venue } = useSelector((state) => state.venue);
  const [venuesList, setVenuesList] = useState(null);
  const level = JSON.parse(localStorage.getItem("levelSelected"));

  const { cardItems } = useSelector((state) => state.cardSlice);
  const [isUpsellingDialogOpen, setIsUpsellingDialogOpen] = useState(false);
  const { getUserCurrentLocation } = useUserLocationEnabled()
  const { venueId } = useParams();
  const { state } = useLocation();
  const [openCart, setOpenCart] = useState(false);
  const [openCarInformationModal, setOpenCarInformationModal] = useState(false);
  const { triggerLocation } = useGeolocation();
  const [isLoading, setIsLoading] = useState(null);
  const [activeTab, setActiveTab] = useState('reserve');
  const HOLD_TIME_SECONDS = 300;
  const [timeLeft, setTimeLeft] = useState(HOLD_TIME_SECONDS);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const mode = localStorage.getItem("mode");
  const isReservation = localStorage.getItem("isReservation");


  const dispatch = useDispatch();

  const { venueIdToBlock } = useSelector((state) => state.venueLocationModal);
  const handleOpenModal = () => dispatch(openVenueLocationModal());
  const handleOpenVenueFarAwayModal = (venueId) => dispatch(openVenueFarAwayModal(venueId));


  const handleClose = () => {
    setOpenCart(false);
  };


  useEffect(() => {
    if (timeLeft <= 0) {
      localStorage.removeItem("holdStartTime");
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1;
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);


  useEffect(() => {
    const storedTime = localStorage.getItem("holdStartTime");

    if (storedTime) {
      const elapsed = Math.floor((Date.now() - Number(storedTime)) / 1000);
      const remaining = HOLD_TIME_SECONDS - elapsed;

      if (remaining > 0) {
        setTimeLeft(remaining);
      } else {
        setTimeLeft(0);
        localStorage.removeItem("holdStartTime");
      }
    } else {
      const isExpired = timeLeft <= 0;
      if (!isExpired) {
        localStorage.setItem("holdStartTime", Date.now().toString());
      }
    }
  }, []);



  useEffect(() => {
    return () => {
      localStorage.removeItem("holdStartTime");
    };
  }, [location.pathname]);

  const formatTimeBook = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const handleCloseCarInformationModal = () => {
    setOpenCarInformationModal(false);
  };

  const [menuData, setMenuData] = useState([]);
  const [modeOfVenue, setModeOfVenue] = useState({
    isPickUp: false,
    isDineIn: false,
  });
  const [venuesCoverData, setVenuesCoverData] = useState({
    detail: "",
    image: "",
    distance: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedReservationData, setSelectedReservationData] = useState(null);

  const [reservationData, setReservationData] = useState({
    partySize: selectedReservationData && selectedReservationData?.partySize || "",
    date: selectedReservationData && format(new Date(selectedReservationData?.start), 'yyyy-MM-dd') || "",
    startTime: selectedReservationData && format(selectedReservationData?.start, 'hh:mm a') || "",
    endTime: selectedReservationData && format(selectedReservationData?.end, 'hh:mm a') || "",
    venueId: venue?.id,
    levelId: level?.id,
    tableId: "",
    createdBy: user?.id,
    areaId: "",
    customer: {
      name: selectedReservationData && selectedReservationData?.customerName || "",
      phone: selectedReservationData && selectedReservationData?.customerPhone || "",
      email: selectedReservationData && selectedReservationData?.customerEmail || "",
    },
    reservationType: selectedReservationData && selectedReservationData?.reservationType || "",
  });
  const convertDateAndTimeToLocalIsoFormat = (date, time) => {
    const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
    const [hours, minutes] = parse(time, 'hh:mm a', new Date())
      .toLocaleTimeString('en-US', { hour12: false })
      .split(':')
      .map(Number);

    const combinedDateTime = set(parsedDate, { hours, minutes });
    const year = combinedDateTime.getFullYear();
    const month = String(combinedDateTime.getMonth() + 1).padStart(2, "0");
    const day = String(combinedDateTime.getDate()).padStart(2, "0");
    const hoursString = String(combinedDateTime.getHours()).padStart(2, "0");
    const minutesString = String(combinedDateTime.getMinutes()).padStart(2, "0");
    const seconds = String(combinedDateTime.getSeconds()).padStart(2, "0");
    const milliseconds = String(combinedDateTime.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day}T${hoursString}:${minutesString}:${seconds}.${milliseconds}Z`;
  };
  const getReservationsTimeSlots = async () => {
    setIsLoading(true);

    try {
      let payload = {
        date:
          selectedDate,
        time:
          selectedTime,
        partySize:
          selectedTableSize,
        venueId: venue.levels[0].venue,
        levelId: venue.levels[0].id,
      };

      payload.time = convertDateAndTimeToLocalIsoFormat(payload.date, payload.time);

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/reservation/getReservationTimeSlotsWithParams/b2c`,
        {
          params: payload,
        }
      );
      setIsLoading(false);
      setVenuesList(response.data);
      setActiveSection({
        calenderDining: false,
        selectReservationTime: true,
      })
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar("Error while fetching available time slots", { variant: "error" });
    }
  };

  const openNewAPI = () => {
    getReservationsTimeSlots();

  };
  const fetchMenuData = useCallback(async () => {
    const errorMessage = state?.errorMessage;
    const openModal = state?.openModal;

    if (errorMessage) {
      // enqueueSnackbar(errorMessage,{variant:"error"});
      setOpenCart(true)
    }
    if (openModal) {
      setOpenCart(true)
    }
    try {
      setLoading(true);
      const venue = venues.find((venue) => venue.id === venueId);
      const venueResponse = await api.get(
        `${process.env.REACT_APP_BACKEND_URL}/venues/b2c/${venueId}`
      );
      const res = await fetchImage(venueResponse?.data?.photoURL);
      setVenuesCoverData({
        detail: venueResponse?.data,
        image: res,
        distance: venue?.distance,
      });
      const menuResponse = await api.get(
        `${process.env.REACT_APP_BACKEND_URL}/menu/?levelId=${venueResponse?.data?.levels[0]?.id}&venueId=${venueId}&isAvailableOnWebApp=true`
      );
      setModeOfVenue({
        isPickUp: venueResponse?.data?.configurations?.isPickUp,
        isDineIn: venueResponse?.data?.configurations?.isDineIn,
      });
      setMenuData(menuResponse.data.results);

      let orderType = localStorage.getItem("mode");
      let qrScannedVenueId = localStorage.getItem("venueId");
      if ((orderType == 'QrDineIn' || orderType == 'QrPickUp' || orderType == 'carHop') && (venueId == qrScannedVenueId)) {
        localStorage.setItem("isReservation", 'false');
        if (getUserCurrentLocation) {
          getLocation(orderType, venueResponse?.data)
        }
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [venueId, venues]);

  const getLocation = useCallback(async (orderType, venueData) => {
    try {
      const location = await triggerLocation(handleOpenModal)
      const response = await api.get(
        `${process.env.REACT_APP_BACKEND_URL}/venues/${venueId}/getLiveDistanceFromVenue/`,
        {
          params: {
            location: location,

          }
        }
      );

      if (response.data.result.distance > process.env.REACT_APP_LOCATION_RESTRICTION_FOR_ORDER && (((orderType == "pickUp") && venueData?.configurations?.isLocationRestrictionForPickUp == true) || ((orderType == "QrDineIn" || orderType == "dineIn") && venueData?.configurations?.isLocationRestrictionForQrTable == true) || (orderType == "carHop" && venueData?.configurations?.isLocationRestrictionForQrCarHop == true) || (orderType == "QrPickUp" && venueData?.configurations?.isLocationRestrictionForQrVenue == true))) {
        handleOpenVenueFarAwayModal(venueId)
      }
      if (orderType == "QrDineIn" || orderType == "dineIn") {
        await dispatch(getVenueListWithLocationAndType(location, "isDineIn", true));
      } else if (orderType == "QrPickUp" || orderType == "carHop" || orderType == "pickUp") {
        await dispatch(getVenueListWithLocationAndType(location, "isPickUp", true));
      }

      // else if(orderType == "reservation"){
      //   let partySize = "5";
      //   let time = "2025-02-06T13:00:00.000Z"
      //     await dispatch(getVenueListforReservation(location,partySize , time));
      //   }


    } catch (error) {
      console.log(error)
    }
  }, [venueId, venues]);

  useEffect(() => {
    fetchMenuData();
  }, []);


  return (
    <>
      <VenueHeader />
      {loading ? (
        <LoadingScreen width="100px" height="100px" marginT="0" h="100vh" />
      ) : (
        <>
          <VenueCover
            venuesCoverData={venuesCoverData}
            menu={menuData}
          />
          {isReservation == 'true' &&
            <Box
              sx={{
                background: "#fff",
                borderRadius: "10px",
                p: {
                  lg: "0px 50px 0px 50px",
                  xl: "0px 50px 0px 50px",
                },
              }}
            >
              <Container maxWidth="xl">

                <Box sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  mt: 2,
                }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="fullWidth"
                  >
                    <Tab label="Reserve" value="reserve" />
                    <Tab label="Menu" value="menu" />
                  </Tabs>
                </Box>
              </Container>
            </Box>
          }
          {isReservation === 'true' && confirmationPage && (
            <Box sx={{ backgroundColor: '#fff', padding: '10px 20px', textAlign: 'center' }}>
              <Typography variant="body1" color="black" fontWeight={"bold"}>
                {timeLeft > 0
                  ? `Due to limited availability, we can hold this table for you for ${formatTimeBook(timeLeft)} minutes`
                  : "Your reservation hold has expired due to limited availability."}
              </Typography>
            </Box>
          )}


          {(activeTab == 'menu' || isReservation == 'false') && <VenueProfileMenu
            venueIdToBlock={venueIdToBlock}
            item={menuData}
            venuesCoverData={venuesCoverData}
            modeOfVenue={modeOfVenue}
            venueId={venueId}
          />
          }
          {(isReservation == 'true' && activeTab == 'reserve') && !confirmationPage ? <SelectReservationTime
            venuesList={venuesList}
            isLoading={isLoading}
            reservationData={reservationData}
            setReservationData={setReservationData}
            getReservationsTimeSlots={getReservationsTimeSlots}
            setIsLoading={setIsLoading}
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            selectedTableSize={selectedTableSize}
            selectedDateDft={selectedDate}
            selectedTime={selectedTime}
            detail={detail}
          />
            :
            (isReservation == 'true' && activeTab == 'reserve') && confirmationPage &&
            <ReservationCheckoutSummary
              selectedSlot={selectedSlot}
              selectedTableSize={selectedTableSize}
              checkView={logginView}
              timeLeft={timeLeft}
            />
          }
        </>
      )}
      <FooterLogin />
      {openCart && cardItems?.data?.items?.length > 0 && (
        <CartItemModal width="md" open={openCart} onClose={handleClose} setOpenCarInformationModal={setOpenCarInformationModal} errorMessage={state?.errorMessage}
          isUpsellingDialogOpen={isUpsellingDialogOpen} setIsUpsellingDialogOpen={setIsUpsellingDialogOpen} />
      )}
      {openCarInformationModal && (
        <CarInformationModal width="md" open={openCarInformationModal} onClose={handleCloseCarInformationModal} user={user} />
      )}
    </>
  );
};

export default VenueProfiles;
